import React, { useState, useEffect } from "react";
import { Row, Col, Card, Divider, Tabs, message } from "antd";
import { PieChartOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import ReactEcharts from "echarts-for-react";
import http from "../../../services/http";

const options_status = {
  [-1]: "Em formação",
  [0]: "Aguard. Avaliação.",
  [1]: "Ideia aceita (Aguard. info.)",
  [2]: "Ideia c/ oportunidade",
  [3]: "Retorno de info.",
  [4]: "Em desenvolvimento",
  [5]: "Finalizado",
};

export const SugestoesIndicadores = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // INDICADORES
  const [mesIndicadores, setMesIndicadores] = useState({});
  const [filialIndicadores, setFilialIndicadores] = useState({});
  const [classificacaoIndicadores, setClassificacaoIndicadores] = useState({});
  const [areaIndicadores, setAreaIndicadores] = useState({});
  const [statusIndicadores, setStatusIndicadores] = useState({});

  useEffect(() => {
    carregarSugestoesIndicadores();
  }, []);

  // CARREGAR DADOS GRÁFICO
  const carregarSugestoesIndicadores = async () => {
    setLoading(true);
    const api = await http("get", `v1/sugestoes/indicadores`, []);
    if (api.statusCode === 200) {
      // MES INDICADORES -------------------
      let mes_desc = [];
      let mes_values = [];

      api?.response?.data?.mes?.forEach((m) => {
        mes_desc.push(m.data);
        mes_values.push(m.total);
      });

      let mes_config = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: mes_desc,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: mes_values,
            type: "bar",
          },
        ],
        color: "#b7d69b",
      };
      setMesIndicadores(mes_config);

      // FILIAL INDICADORES -------------------
      let filial_desc = [];
      let filial_values = [];

      api?.response?.data?.filial?.forEach((f) => {
        filial_desc.push(f.filial);
        filial_values.push(f.total);
      });

      let filial_config = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: filial_desc,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: filial_values,
            type: "bar",
          },
        ],
        color: "#b7d69b",
      };
      setFilialIndicadores(filial_config);

      // CLASSIFICAÇÃO INDICADORES -------------------
      let classificacao_desc = [];
      let classificacao_values = [];

      api?.response?.data?.classificacao?.forEach((c) => {
        classificacao_desc.push(c.classificacao);
        classificacao_values.push(c.total);
      });

      let classificacao_config = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: classificacao_desc,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: classificacao_values,
            type: "bar",
          },
        ],
        color: "#b7d69b",
      };
      setClassificacaoIndicadores(classificacao_config);

      // AREA INDICADORES -------------------
      let area_desc = [];
      let area_values = [];

      api?.response?.data?.area?.forEach((a) => {
        area_desc.push(a.area);
        area_values.push(a.total);
      });

      let area_config = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: area_desc,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: area_values,
            type: "bar",
          },
        ],
        color: "#b7d69b",
      };
      setAreaIndicadores(area_config);

      // SATUS INDICADORES -------------------
      let status_desc = [];
      let status_values = [];

      api?.response?.data?.status?.forEach((s) => {
        status_desc.push(options_status[s.status]);
        status_values.push(s.total);
      });

      let status_config = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: status_desc,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: status_values,
            type: "bar",
          },
        ],
        color: "#b7d69b",
      };
      setStatusIndicadores(status_config);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const items = [
    {
      key: "1",
      label: `Por Mês`,
      children: (
        <div className="scroll-x">
          <ReactEcharts
            // style={{minWidth: 800}}
            option={mesIndicadores && mesIndicadores}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: `Por Filial`,
      children: (
        <div className="scroll-x">
          <ReactEcharts
            // style={{minWidth: 800}}
            option={filialIndicadores && filialIndicadores}
          />
        </div>
      ),
    },
    {
      key: "3",
      label: `Por Classificação`,
      children: (
        <div className="scroll-x">
          <ReactEcharts
            // style={{minWidth: 800}}
            option={classificacaoIndicadores && classificacaoIndicadores}
          />
        </div>
      ),
    },
    {
      key: "4",
      label: `Por Área`,
      children: (
        <div className="scroll-x">
          <ReactEcharts
            // style={{minWidth: 800}}
            option={areaIndicadores && areaIndicadores}
          />
        </div>
      ),
    },
    {
      key: "5",
      label: `Por Status`,
      children: (
        <div className="scroll-x">
          <ReactEcharts
            // style={{minWidth: 800}}
            option={statusIndicadores && statusIndicadores}
          />
        </div>
      ),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Sugestões Indicadores"
              subtitle="Gráficos de sugestões recebidas"
              icon={<PieChartOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Tabs defaultActiveKey="1" items={items} />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
